<template>
  <div class="position-relative overflow-auto">
    <div class="d-inline-flex flex-nowrap rounded-pill p-1 ai-custom-checkbox welcome-pill-buttons" style="min-width: max-content;">
      <b-button
        size="sm"
        type="button"
        :variant="value === 'ki' ? 'light' : 'link'"
        :class="[
          'rounded-pill px-3 text-nowrap mr-1',
          value === 'ki' ? 'bg-white shadow-sm text-dark border-0' : 'text-secondary'
        ]"
        @click="emitValue('ki')"
      >
        {{ translations[15926] }}
      </b-button>
      <b-button
        size="sm"
        type="button"
        :variant="value === 'berufsgruppe' ? 'light' : 'link'"
        :class="[
          'rounded-pill px-3 text-nowrap mr-1',
          value === 'berufsgruppe' ? 'bg-white shadow-sm text-dark border-0' : 'text-secondary'
        ]"
        @click="emitValue('berufsgruppe')"
      >
        {{ translations[3848] }}
      </b-button>
      <b-button
        v-if="showVolltext"
        size="sm"
        type="button"
        :variant="value === 'volltext' ? 'light' : 'link'"
        :class="[
          'rounded-pill px-3 text-nowrap',
          value === 'volltext' ? 'bg-white shadow-sm text-dark border-0' : 'text-secondary'
        ]"
        @click="emitValue('volltext')"
      >
        {{ translations[10434] }}
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

export type AiCustomCheckboxValue = 'ki' | 'berufsgruppe' | 'volltext';

@Component({})
export default class AiCustomCheckbox extends Vue {
  @Prop({ type: String, default: 'ki' }) value!: AiCustomCheckboxValue;

  @Prop({ type: Boolean, default: true }) showVolltext!: boolean;

  emitValue(mode: AiCustomCheckboxValue) {
    this.$emit('input', mode);
  }

  get translations() {
    return AppModule.translation;
  }
}
</script>

<style lang="scss" scoped>
.welcome-pill-buttons {
  .btn-link {
    text-decoration: none;
    &:hover {
      text-decoration: none;
    }
  }

  // на мобілі таби мають вміщатися в ширину банера, без горизонтального скролу
  @media (max-width: 575.98px) {
    min-width: 0 !important;
    display: flex;
    width: 100%;

    .btn {
      flex: 1 1 auto;
      min-width: 0;
      padding-left: 0.35rem !important;
      padding-right: 0.35rem !important;
      font-size: 13px;
      // якщо переклад надто довгий — обрізаємо трикрапкою замість обрізання «в нікуди»
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  // вузькі телефони (iPhone SE тощо)
  @media (max-width: 400px) {
    .btn {
      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;
      font-size: 12px;
    }
  }

  @media (max-width: 360px) {
    .btn {
      font-size: 11px;
    }
  }
}
</style>
